export default __webpack_public_path__ + "static/portrait5-18661499bd7968420b357c9c4e88eb92.png";